import { Feedback } from "../interfaces/feedback.interface";
import axios from "axios";

class FeedbackService {
    sendFeedback(feedback: Feedback) {
        return new Promise<boolean>((resolve, reject) => {
            axios({
                method: 'POST',
                url: `/original/feedback`,
                data: feedback
            }).then((res) => {
                if (res.status === 201) {
                    resolve(res.data.success);
                } else {
                    reject(res.data.success);
                }
            }).catch((err: any) => {
              console.log(err.message);
                reject(err.message);
            });
        });
    }
}

export const feedbackService = new FeedbackService();